// extracted by mini-css-extract-plugin
module.exports = {"requiredFieldsLabel":"CredentialsForm_requiredFieldsLabel__jDzyk"};